import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import HouseCarouselSkeleton from '@/components/home/housesCarousel/houseCarouselSkeleton/HouseCarouselSkeleton';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
import Home from '../Home';
import Footer from '@/components/layout/footer/Footer';
const renderCarousels = (props, isWhiteLabel) => {
  // const Home = dynamic(() => import('@/components/home/Home'), {
  //   ssr: false,
  //   loading: HouseCarouselSkeleton,
  // })
  // const AddToHome = dynamic(
  //   () => import('@/components/home/addToHome/AddToHome'),
  //   {
  //     ssr: false,
  //   },
  // )

  // const Footer = dynamic(() => import('@/components/layout/footer/Footer'), {
  //   ssr: false,
  // })
  const ActiveReserve = dynamic(() => import('@/components/home/activeReserve/ActiveReserve'), {
    ssr: false
  });
  return <>
      <Home data={props} data-sentry-element="Home" data-sentry-source-file="LazyLoadedComponents.tsx" />
      {!isWhiteLabel && <Footer />}
      {/* {!isWhiteLabel && <AddToHome />} */}
      <ActiveReserve data-sentry-element="ActiveReserve" data-sentry-source-file="LazyLoadedComponents.tsx" />
    </>;
};
const LazyLoadedComponents = ({
  props
}) => {
  // const [loaded, setLoaded] = useState(false)
  const isWhiteLabel = useIsWhiteLabel();

  // useEffect(() => {
  //   const onFirstInteraction = () => {
  //     setLoaded(true)
  //     window.removeEventListener('mousemove', onFirstInteraction)
  //     window.removeEventListener('touchstart', onFirstInteraction)
  //     window.removeEventListener('scroll', onFirstInteraction)
  //   }
  //   window.addEventListener('mousemove', onFirstInteraction, { once: true })
  //   window.addEventListener('touchstart', onFirstInteraction, { once: true })
  //   window.addEventListener('scroll', onFirstInteraction, { once: true })

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  return renderCarousels(props, isWhiteLabel);

  // return loaded ? (
  //   renderCarousels(props, isWhiteLabel)
  // ) : (
  //   <HouseCarouselSkeleton />
  // )
};
export default LazyLoadedComponents;